import { ReactNode } from 'react'

import { AstraParagraph } from '~/astra'

type ModalElementHeadingProps = {
    children: ReactNode
    className?: string
}

export const ModalElementHeading = ({ children, className }: ModalElementHeadingProps) => (
    <AstraParagraph variant="body-small" weight="medium" className={className}>
        {children}
    </AstraParagraph>
)

type SecondaryLabel = {
    label: string
    count: number
    maxCount: number
}

type ModalElementProps = (
    | { label: string; secondaryLabel?: never; hasItems?: never }
    | { label?: never; secondaryLabel: SecondaryLabel; hasItems: boolean }
) & {
    children: ReactNode
}

export const ModalElement = ({ children, label, secondaryLabel, hasItems = true }: ModalElementProps) => (
    <div className="pointer-events-auto px-3 pb-3 pt-2">
        <div className="flex items-center justify-between gap-2">
            {label && <ModalElementHeading>{label}</ModalElementHeading>}
            {secondaryLabel && (
                <div className="flex w-full items-center justify-between gap-2">
                    <AstraParagraph variant="body-extra-small" weight="medium" className="uppercase text-muted">
                        {secondaryLabel.label}
                    </AstraParagraph>
                    <AstraParagraph variant="body-extra-small" weight="medium" className="uppercase text-muted">
                        {secondaryLabel.count}/{secondaryLabel.maxCount}
                    </AstraParagraph>
                </div>
            )}
        </div>

        {hasItems && <div className="mt-3 grid grid-cols-3 gap-2">{children}</div>}
    </div>
)
